var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middle-page"},[_c('img',{attrs:{"src":"http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E6%88%90%E5%8A%9F.svg"}}),_c('h3',[_vm._v("感谢您的提交")]),_c('span',[_vm._v("前往员工社区 -【星圈】继续探索复星圈内的事儿")]),_c('button',{on:{"click":_vm.goHome}},[_vm._v("立即跳转 "+_vm._s(_vm.second)+"s")])])
}
var staticRenderFns = []

export { render, staticRenderFns }